"use client";
import RecentApplicants from "@/components/ecommerce/RecentApplicants";
import RecentSubscriptions from "@/components/ecommerce/RecentSubscriptions";
import { isAdmin } from "@/utils/auth";
import { useEffect, useState } from "react";
import DashboardOverviewClient from "./DashboardOverviewClient";

export default function DashboardClient() {
  const [adminStatus, setAdminStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Check admin status on component mount
  useEffect(() => {
    setAdminStatus(isAdmin());
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return (
      <div className="grid grid-cols-12 gap-4 md:gap-6">
        <DashboardOverviewClient />
        <div className="col-span-12 xl:col-span-6">
          <RecentApplicants />
        </div>
        <div className="col-span-12 xl:col-span-6">
          <div className="text-center py-8 text-gray-500 dark:text-gray-400">
            Loading...
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-12 gap-4 md:gap-6">
      <DashboardOverviewClient />
      <div className={`${adminStatus ? 'col-span-12 xl:col-span-6' : 'col-span-12'}`}>
        <RecentApplicants />
      </div>
      {/* Only show subscriptions if user is admin */}
      {adminStatus && (
        <div className="col-span-12 xl:col-span-6">
          <RecentSubscriptions />
        </div>
      )}
    </div>
  );
} 